export const StatusEnum = Object.freeze({
  RECEIVED: "RECEIVED",
  PARTIALLY_INVOICED: "PARTIALLY_INVOICED",
  FULLY_INVOICED: "FULLY_INVOICED",
});
